import memoizeOne from 'memoize-one';

import { performGetRequest } from '@atlassian/jira-fetch';

const fetchBillingDetails = (cloudId: string) =>
	performGetRequest(`/gateway/api/billing-ux/cloud/${cloudId}/billing/billing-details`, {
		headers: {
			'Content-Type': 'application/json',
		},
	});

const memoizedFetchBillingDetails = memoizeOne(fetchBillingDetails);

export const getBillingInformationHAMS = async (cloudId: string) => {
	if (!cloudId) throw new Error('empty cloudId');

	const billingDetails = await memoizedFetchBillingDetails(cloudId);

	return {
		invoiceable: Boolean(
			billingDetails?.paymentMethod && billingDetails?.paymentMethod !== 'NO_DETAILS',
		),
	};
};
